<template>
    <div class="statusbar">
        <status :status="status"></status>
        <span class="time-ago">
            Last edited: <timeago :since="updatedAt"></timeago>
        </span>
    </div>
</template>

<script>
  import status from '@/components/admin/common/status'

  export default {
    name: 'statusbar',
    props: ['status', 'updatedAt'],
    components: {
      status
    }
  }
</script>
<style lang="scss" scoped>
    .time-ago {
        padding: 5px 10px;
        background: #dcdcdc;
        margin-right: 15px;
        font-style: italic;
    }
</style>


// WEBPACK FOOTER //
// statusbar.vue?4d0dd6cc